import { gsap } from 'gsap';

import { ElementsManager } from './ElementsManager';

export class NotificationMananger {
  private notificationContainer: HTMLElement;
  private notificationText: HTMLElement;
  private elementsManager: ElementsManager = new ElementsManager();
  private preloader: HTMLElement;
  public constructor() {
    this.notificationContainer = this.elementsManager.elements.notifications as HTMLElement;
    this.notificationText = this.elementsManager.elements.notificationsText as HTMLElement;
    if (this.notificationContainer) this.notificationContainer.style.visibility = 'hidden';
    this.preloader = this.elementsManager.elements.preloader as HTMLElement;
  }

  private createNotification(message: string, type: 'loading' | 'error' = 'loading') {
    if (this.notificationContainer) {
      if (this.preloader) gsap.set(this.preloader, { autoAlpha: 0 });

      //const notification = document.createElement('div');
      this.notificationText.textContent = message;
      // notification.style.margin = '5px';
      // notification.style.padding = '10px';
      // notification.style.borderRadius = '5px';
      this.notificationContainer.style.visibility = 'visible';
      gsap.to(this.notificationContainer, {
        duration: 2,
        autoAlpha: 1,
      });
      this.notificationText.textContent = message;
      gsap.to(this.notificationContainer, {
        delay: 2.3,
        duration: 0.3,
        autoAlpha: 0,
      });
    }
  }
  public show(message = 'Loading...'): void {
    this.createNotification(message, 'loading');
  }
  public showLoading(message = 'Loading...'): void {
    this.preloader.style.visibility = 'visible';

    gsap.to(this.preloader, {
      duration: 0.1,
      autoAlpha: 1,
      display: 'flex',
    });
    this.createNotification(message, 'loading');
    //this.notificationContainer.appendChild(loadingNotification);

    // setTimeout(() => {
    //   this.notificationContainer.removeChild(loadingNotification);
    // }, 5000); // e.g., auto-remove after 5 seconds
  }
  public showLoadingDone(message = 'Loading...'): void {
    gsap.to(this.preloader, {
      duration: 0.3,
      autoAlpha: 0,
    });
  }
  public showError(message = 'An error occurred.'): void {
    console.log('showError', message);
    this.createNotification(message, 'error');
    //this.notificationContainer.appendChild(errorNotification);

    // You can also add an auto-remove for error messages after a longer duration
    // setTimeout(() => {
    //   this.notificationContainer.removeChild(errorNotification);
    // }, 10000); // e.g., auto-remove after 10 seconds
  }
}
